module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_cohen_sm-44d9765a69a5ac30b326f6b2cb45ddf6.png";